
import { useTranslation } from 'react-i18next';
import Card from '../../../components/base/Card';

export default function Features() {
  const { t } = useTranslation();
  
  const features = [
    {
      icon: 'ri-gamepad-line',
      title: t('Interactive Learning'),
      description: t('Learn English through real BMX and skateboarding scenarios, making lessons engaging and memorable.'),
      image: 'https://public.readdy.ai/ai/img_res/0061f1434bef5d9690ca85a4b5433bdf.jpg'
    },
    {
      icon: 'ri-user-star-line',
      title: t('Expert Instructors'),
      description: t('Our native English-speaking instructors are also passionate action sports enthusiasts.'),
      image: 'https://readdy.ai/api/search-image?query=Experienced%20English%20teacher%20conducting%20online%20lesson%20with%20action%20sports%20theme%2C%20professional%20instructor%20with%20BMX%20helmet%20and%20skateboard%20visible%20in%20background%2C%20modern%20home%20teaching%20studio%20with%20excellent%20lighting%2C%20confident%20and%20enthusiastic%20demeanor%2C%20high-quality%20webcam%20setup%20for%20online%20education&width=400&height=300&seq=feature-instructor&orientation=landscape'
    },
    {
      icon: 'ri-time-line',
      title: t('Flexible Schedule'),
      description: t('Take classes anytime, anywhere with our online platform designed for busy lifestyles.'),
      image: 'https://readdy.ai/api/search-image?query=Student%20taking%20English%20class%20on%20laptop%20at%20skate%20park%20during%20sunset%2C%20flexible%20learning%20environment%20showing%20freedom%20to%20study%20anywhere%2C%20skateboard%20and%20BMX%20bike%20nearby%2C%20beautiful%20golden%20hour%20lighting%2C%20modern%20technology%20enabling%20learning%20on%20the%20go%2C%20inspiring%20outdoor%20study%20session&width=400&height=300&seq=feature-flexible&orientation=landscape'
    },
    {
      icon: 'ri-team-line',
      title: t('Community Focus'),
      description: t('Connect with fellow action sports lovers while improving your English communication skills.'),
      image: 'https://readdy.ai/api/search-image?query=Group%20of%20diverse%20young%20people%20having%20English%20conversation%20practice%20at%20modern%20skate%20park%2C%20multicultural%20friends%20discussing%20action%20sports%20in%20English%2C%20natural%20social%20interaction%20with%20skateboards%20and%20BMX%20bikes%20around%2C%20sunny%20day%20with%20positive%20community%20atmosphere%2C%20real-world%20English%20practice%20scenario&width=400&height=300&seq=feature-community&orientation=landscape'
    }
  ];
  
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('Why Choose Action English?')}
          </h2>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <Card key={index} hover className="p-8 text-center h-full">
              <div className="mb-6">
                <img 
                  src={feature.image} 
                  alt={feature.title}
                  className="w-full h-48 object-cover object-center rounded-lg mb-4"
                />
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
                  <i className={`${feature.icon} text-3xl text-blue-600`}></i>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
